module.exports = __webpack_public_path__ + "img/technology-4.c70ec8f8.svg";